import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import './InputWithHours.scss';

export default class InputWithHours extends Component {
  handleClick = () => {
    const { number } = this.props;

    this.props.callback(number);
  };

  render() {
    const {
      value,
      icon,
      placeholder,
      onChange,
      onKeyPress,
      template,
      onClick,
      disabled,
      id,
      maxLength,
      isHideButton,
      number,
    } = this.props;

    return (
      <div className={`InputWithHours${template ? ` template-${template}` : ''}`}>
        <div className={'group-input'}>
          <span className="text">{number + 1} {number > 0 ? 'hrs' : 'hr' }</span>
          <Input
            id={id}
            placeholder={placeholder}
            value={value}
            onChange={event => onChange(event)}
            onKeyPress={onKeyPress}
            onClick={onClick}
            disabled={disabled}
            maxLength={maxLength}
          />
          <span className={`icon ${icon}${isHideButton ? 'hide-button' : ''}`} onClick={this.handleClick}>
          </span>
        </div>
      </div>
    );
  }
}

InputWithHours.propTypes = {
  'id': PropTypes.string,
  'value': PropTypes.any,
  'icon': PropTypes.string,
  'placeholder': PropTypes.string,
  'type': PropTypes.string,
  'onChange': PropTypes.func.isRequired,
  'onKeyPress': PropTypes.func,
  'template': PropTypes.string,
  'onClick': PropTypes.func,
  'disabled': PropTypes.bool,
  'maxLength': PropTypes.string,
};
